

export const VISIBILITY_OPTIONS = [
  {
    key: "public",
    label: "LABEL_PUBLIC",
    description: "HINT_PUBLIC_VISIBILITY",
  },
  {
    key: "group",
    label: "LABEL_GROUP",
    description: "HINT_GROUP_VISIBILITY",
  },
  {
    key: "specific",
    label: "LABEL_SPECIFIC",
    description: "HINT_SPECIFIC_PEOPLE_VISIBILITY",
  },
  {
    key: "private",
    label: "LABEL_PRIVATE",
    description: "HINT_ONLY_ME_VISIBILITY",
  },
];
